<template>
    <div id="app">
        <router-view></router-view>
    </div>
</template>

<script>

    export default {
        name: 'app',
        created() {
            this.resetTitle()
        },
        methods: {
            resetTitle() {
                if (this.$route.meta.title) {
                    document.title=this.$route.meta.title
                }
            }
        },
        watch: {
            "$route": function () {
                This.resetTitle()
            }
        }
    }
</script>

<style>
    #app {

    }
</style>
